import ActivityForm from "components/ActivityForm";
import ErrorBoundary from "components/Errors/ErrorBoundary";
import React from "react";
import DashboardLayout from "../components/Layouts/DashboardLayout";

function TaskPage() {
	return (
		<DashboardLayout>
			<ErrorBoundary>
				<ActivityForm />
			</ErrorBoundary>
		</DashboardLayout>
	);
}

export default React.memo(TaskPage);
